export function toContentHref(contentRef: string): string {
  return `/content/${encodeURIComponent(contentRef)}`;
}
